import { useMarriottAIPreviewStore } from '../store';

/**
 * Check if a response is a 401 Unauthorized error.
 * @param response - The fetch Response object
 * @returns true if the response status is 401
 */
export function isUnauthorizedResponse(response: Response): boolean {
  return response.status === 401;
}

/**
 * Handle 401 Unauthorized responses by calling the signout API and redirecting.
 * Follows the same pattern as MemberPanel's handleLogoutClick.
 * Gets logoutLinkPath from the signInDrawerModel in the store.
 *
 * This function will redirect the page, so it effectively never returns
 * in the success case.
 */
export async function handleUnauthorizedError(): Promise<void> {
  const logoutLinkPath = useMarriottAIPreviewStore.getState().signInDrawerModel?.resourceProperties?.logoutLinkPath;

  if (!logoutLinkPath) {
    window.location.reload();
    return;
  }

  try {
    await fetch(logoutLinkPath);
    window.location.reload();
  } catch {
    window.location.reload();
  }
}
